module.exports = __webpack_public_path__ + "static/media/sports.87b1b256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports.jpg
// module id = 1190
// module chunks = 33